import React, { useState, useEffect } from 'react';
import { useNetwork } from '../../contexts/NetworkContext';
import BlockStats from './BlockStats';
import { CHAIN_START } from '../../constants/network';

// Real-time age formatting function
function formatChainAge(): string {
  const now = Date.now();
  const chainAge = now - CHAIN_START.getTime();
  
  const seconds = Math.floor(chainAge / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const years = Math.floor(days / 365.25);

  return [
    years > 0 ? `${years}y` : null,
    days % 365 > 0 ? `${days % 365}d` : null,
    hours % 24 > 0 ? `${hours % 24}h` : null,
    minutes % 60 > 0 ? `${minutes % 60}m` : null,
    `${seconds % 60}s`
  ]
    .filter(Boolean)
    .join(' ');
}

export default function BlockHeightIndicator() {
  const { data, loading } = useNetwork();
  const [currentAge, setCurrentAge] = useState(formatChainAge());
  
  // Update age every second
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAge(formatChainAge());
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  
  if (loading) {
    return (
      <div className="w-full max-w-[280px] mx-auto">
        <div className="bg-slate-900/80 backdrop-blur-sm rounded-lg border border-green-500/20 p-4">
          <div className="animate-pulse space-y-2">
            <div className="h-6 bg-slate-700 rounded w-24" />
            <div className="h-6 bg-slate-700 rounded w-32" />
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="w-full max-w-[320px] mx-auto">
      <div className="bg-slate-900/80 backdrop-blur-sm rounded-lg border border-green-500/20 p-4">
        <BlockStats 
          blockHeight={data.blockcount}
          blockTime={currentAge}
        />
      </div>
    </div>
  );
}